import { useIntl } from "react-intl";
import { calculateUsageCost, TieredPriceProductId } from "@project/common";
import { IconDatabase } from "@tabler/icons-react";
import { INTERNATIONALIZED_UNIT_LABELS } from "../../../constants/productLabels.js";
import { type BasicUsageCardLoaderProps, UsageCard } from "./UsageCard.js";
import { useStorageUsageSum } from "./hooks/fetchSums.js";
import type { To } from "./UsageChartWrapper.js";
import { useProductDescriptions, useProductNames } from "./hooks/productLabels.js";

export const StorageUsageCard = ({
  to,
  productId,
  isLoadingSubscriptions,
}: BasicUsageCardLoaderProps & To) => {
  const {
    usageSum,
    isLoadingStorage,
    isErrorStorage,
  } = useStorageUsageSum({ to });

  const intl = useIntl();
  const getName = useProductNames();
  const getDescription = useProductDescriptions();

  const unitLabel = intl.formatMessage(
    INTERNATIONALIZED_UNIT_LABELS.GB,
  );

  return (
    <UsageCard
      productId={productId}
      usageSum={usageSum}
      unitLabel={unitLabel}
      icon={<IconDatabase />}
      iconColor="pink.1" // #FFCCFF in design, but #ffdeeb from Mantine is close enough.
      isError={isErrorStorage}
      isLoading={isLoadingSubscriptions || isLoadingStorage}
      usageCost={calculateUsageCost(usageSum, productId)}
      defaultProductId={TieredPriceProductId.TieredStorage}
      name={getName(TieredPriceProductId.TieredStorage)}
      description={getDescription(TieredPriceProductId.TieredStorage)}
    />
  );
};
